import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/home.vue'
import Callback from '../views/callback.vue'
import IframeView from '../views/iframe_view.vue'
import StatusPanel  from '../views/StatusPanel.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/callback',
    name: 'Callback',
    component: Callback
  },
  {
    path: '/iframe',
    name: 'Iframe',
    component: IframeView
  },
  {
    path: '/status',
    name: 'StatusPanel',
    component: StatusPanel
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
